import { useEffect, useState } from 'react';
import * as Sqrl from 'squirrelly';
import parse from 'html-react-parser';
import getParserOptions from '../options';
import usePage from '../../../hooks/page';
import LoadingSpinner from '../../../utils/LoadingSpinner';
import { consoleLog } from '../../../utils/Logger';
//import CompilationError from '../../500';
import { initFlowbite } from 'flowbite';

const AuthenticatedPrivatePage = props => {
  const {
    siteMapPage,
    sequencer: { execute, run }
  } = props;

  const { page, html, data, ready } = usePage({
    siteMapPage
  });

  const [parsedHtml, setParsedHtml] = useState();
  const [hasError, setHasError] = useState(false);

  if (data?.local?.logData) {
    console.log({ data });
  }

  consoleLog('AuthenticatedPrivatePage', {
    name: page?.name,
    id: page?.id,
    data,
    ready
  });

  window.actionSequencer = {
    execute,
    run,
    page
  };

  useEffect(() => {
    if (ready) {
      let theHtml = html;
      try {
        if (data.report) {
          theHtml = theHtml.replace('{{it.report.html}}', data.report.html);
        }

        theHtml = parse(
          Sqrl.render(theHtml, data),
          getParserOptions({
            page,
            data
          })
        );
        setParsedHtml(theHtml);
      } catch (err) {
        console.log('AuthenticatedPrivatePage.error', {
          err,
          html: data?.local?.logData ? html : 'redacted'
        });
        setHasError(err);
      }
    }
  }, [ready, page, data, html]);

  useEffect(() => {
    if (parsedHtml) {
      initFlowbite();
    }
  }, [parsedHtml]);

  if (!ready) {
    return <LoadingSpinner />;
  }

  if (hasError) {
    // /return <CompilationError error={hasError} page={page} />;
  }

  return (
    <>
      {page?.css?.trim().length > 0 ? (
        <style type="text/css">{page.css}</style>
      ) : null}
      {parsedHtml}
    </>
  );
};

export default AuthenticatedPrivatePage;
